import React from "react";
import { FiMenu, FiX } from "react-icons/fi";

const CleanNavBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <nav className="clean-navbar">
      <div className="clean-container">
        <div className="navbar-content">
          <a href="/" className="navbar-logo">
            LocalIntent
          </a>
          
          <div className="navbar-links desktop-only">
            <a href="#how-it-works" className="nav-link">How It Works</a>
            <a href="#partner" className="nav-link">Partner With Us</a>
          </div>
          
          <div className="navbar-actions desktop-only">
            <a href="mailto:hello@localintent.ai" className="btn-nav-primary">Contact</a>
          </div>
          
          <button 
            className="mobile-menu-toggle mobile-only"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
        
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <a href="#how-it-works" className="mobile-nav-link">How It Works</a>
            <a href="#partner" className="mobile-nav-link">Partner With Us</a>
            <a href="mailto:hello@localintent.ai" className="mobile-nav-link">Contact</a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default CleanNavBar;